import { Component } from "@angular/core";

@Component({
  selector: "ab-apdex-tooltip-text",
  templateUrl: "./apdex-tooltip-text.component.html",
})
export class ApdexTooltipTextComponent {}
